// 채널별 내 페이지 링크: 내 공개 페이지 주소에 UTM 을 붙인 단축 URL. 단축 URL 탭(FgChannelLinks)과 유입분석 UTM 표가 같이 쓴다
// 방문자가 보는 공개 주소. REACT_APP_PAGE_CLIENT_URL(운영 page.shool.uk)은 미리보기용이라 쓰지 않는다 (FdLinkAlert 와 같은 주소)
const PUBLIC_PAGE_URL = 'https://shool.uk';

export const CHANNELS = [
    { key: 'youtube', label: '유튜브', source: 'youtube', medium: 'bio', icon: 'youtube', guide: '채널 맞춤설정 > 기본 정보 > 링크에 붙여 넣으세요' },
    { key: 'instagram_bio', label: '인스타 바이오', source: 'instagram', medium: 'bio', icon: 'instagram', guide: '프로필 편집 > 링크 추가에 붙여 넣으세요' },
    { key: 'instagram_story', label: '인스타 스토리', source: 'instagram', medium: 'story', icon: 'instagram', guide: '스토리의 링크 스티커에 붙여 넣으세요' },
    { key: 'tiktok', label: '틱톡', source: 'tiktok', medium: 'bio', icon: 'tiktok', guide: '프로필 편집 > 웹사이트에 붙여 넣으세요' },
    { key: 'kakaotalk', label: '카카오톡', source: 'kakaotalk', medium: 'chat', icon: 'kakaotalk', guide: '오픈채팅 공지·채널 소식·메시지에 붙여 넣으세요' },
    { key: 'naver_blog', label: '네이버 블로그', source: 'naver_blog', medium: 'post', icon: 'naver', guide: '글 본문이나 블로그 프로필에 붙여 넣으세요' },
    { key: 'threads', label: '스레드', source: 'threads', medium: 'bio', icon: 'threads', guide: '프로필 편집 > 링크에 붙여 넣으세요' },
];

export const CUSTOM_MEDIUM = 'etc';

export function pageUrl(domainName) {
    return `${PUBLIC_PAGE_URL}/${domainName}`;
}

/** 채널 링크의 원본 주소: 내 페이지 + utm_source·utm_medium(·utm_campaign) */
export function channelTargetUrl(domainName, { source, medium }, campaign) {
    const url = new URL(pageUrl(domainName));
    url.searchParams.set('utm_source', source);
    url.searchParams.set('utm_medium', medium);
    if (campaign) {
        url.searchParams.set('utm_campaign', campaign);
    }
    return url.href;
}

/** 단축 URL 의 원본 주소가 내 페이지 채널 링크면 { source, medium, campaign, channel } (channel 은 미리 정한 채널이 아니면 null) */
export function parseChannelLink(url, domainName) {
    try {
        const parsed = new URL(url);
        const page = new URL(pageUrl(domainName));
        const source = parsed.searchParams.get('utm_source');
        if (parsed.host !== page.host || decodeURIComponent(parsed.pathname) !== `/${domainName}` || !source) {
            return null;
        }
        const medium = parsed.searchParams.get('utm_medium') || null;
        return { source, medium, campaign: parsed.searchParams.get('utm_campaign') || null, channel: findChannel(source, medium) };
    } catch (error) {
        return null;
    }
}

export function findChannel(source, medium) {
    return CHANNELS.find(c => c.source === source && c.medium === medium) || null;
}

// 플랫폼 로고: public/assets/icons/brands/<icon>.svg — Simple Icons 16.35.0 (https://simpleicons.org, CC0) 원본에 브랜드 색(fill)만 넣음.
// 로고 상표권은 각 회사에 있다. 새 채널은 https://cdn.jsdelivr.net/npm/simple-icons@16.35.0/icons/<slug>.svg 를 받아 같은 방식으로 추가
export function ChannelIcon({ channel, className = 'h-[18px] w-[18px]' }) {
    return channel?.icon
        ? <img src={`/assets/icons/brands/${channel.icon}.svg`} alt="" className={`shrink-0 ${className}`} />
        : <img src="/assets/icons/link_default_000000.svg" alt="" className={`shrink-0 opacity-50 ${className}`} />; // 직접 입력한 채널
}
